// extracted by mini-css-extract-plugin
module.exports = {"anchor":"styles__anchor___3Lv-v"};